import { render, staticRenderFns } from "./FooterMainMenuCard.vue?vue&type=template&id=c4454c7a"
import script from "./FooterMainMenuCard.vue?vue&type=script&lang=js"
export * from "./FooterMainMenuCard.vue?vue&type=script&lang=js"
import style0 from "./FooterMainMenuCard.vue?vue&type=style&index=0&id=c4454c7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports